import React, { FC, memo } from 'react';
import styles from './index.module.scss';
import { V2ElectricMapConfigOverviewDetailPostResponse } from '@maxtropy/device-customer-apis-v2';
import { useRequest } from 'ahooks';
import { apiV2ElectricMapDataAlarmCountPost } from '@maxtropy/device-customer-apis-v2';

interface CenterBottomBoxProps {
  className?: string;
  configDetail?: V2ElectricMapConfigOverviewDetailPostResponse;
}

const CenterBottomBox: FC<CenterBottomBoxProps> = ({ className, configDetail }) => {
  const { data: alarmData } = useRequest(() => apiV2ElectricMapDataAlarmCountPost({}));

  return (
    <div
      className={`${styles.container} ${className || ''}`}
      onClick={() =>
        window.open(
          `/device/alarm/record?startTime=${alarmData?.startTime}&endTime=${alarmData?.endTime}&labelIds=${configDetail?.labelIds}`,
          '_blank'
        )
      }
    >
      <div className={styles.title}>近七日未恢复报警</div>
      <div className={styles.alarmBox}>
        <div className={styles.highest}>
          <div className={styles.num}>{alarmData?.topHighAlarmNum ?? 0}</div>
          <div className={styles.text}>最高级</div>
        </div>
        <div className={styles.high}>
          <div className={styles.num}>{alarmData?.highAlarmNum ?? 0}</div>
          <div className={styles.text}>高级</div>
        </div>
        <div className={styles.middle}>
          <div className={styles.num}>{alarmData?.middleAlarmNum ?? 0}</div>
          <div className={styles.text}>中级</div>
        </div>
        <div className={styles.low}>
          <div className={styles.num}>{alarmData?.lowerAlarmNum ?? 0}</div>
          <div className={styles.text}>低级</div>
        </div>
        <div className={styles.lowest}>
          <div className={styles.num}>{alarmData?.earlyWarningAlarmNum ?? 0}</div>
          <div className={styles.text}>最低级</div>
        </div>
      </div>
    </div>
  );
};

export default memo(CenterBottomBox);
